/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Request Direction
 */
export type FundRequestDirection = typeof FundRequestDirection[keyof typeof FundRequestDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FundRequestDirection = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  NONE: 'NONE',
} as const;
